const defaultState = () => {
	return {
		actionsStatusList: null,
      actionsPriorityList: null,
      actionsOwnerList: null,
      actionsCategoryList: null,
	}
}

const state = () => ({
	actionsStatusList: null,
   actionsPriorityList: null,
   actionsOwnerList: null,
   actionsCategoryList: null,
   
});

const getters = {}

const actions = {
   resetState({ commit }) {
      commit("resetState")
   },
};

const mutations = {
   resetState(state) {
      Object.assign(state, defaultState());
   },
   setActionsStatusList(state, list) {
      state.actionsStatusList = list;
   },
   setActionsPriorityList(state, list) {
      state.actionsPriorityList = list;
   },
   setActionsOwnerList(state, list) {
      state.actionsOwnerList = list;
   },
   setActionsCategoryList(state, list) {
      state.actionsCategoryList = list;
   },
};

export default {
   name: "actionsRegister",
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};